<template>
  <div>
    <el-form
      :model="form"
      ref="formRef"
      :rules="formRules"
      label-suffix=":"
      label-width="100px"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="版本类型" prop="versionType">
             <el-select
              v-model="form.versionType"
              style="width: 100%"
              placeholder="请选择版本类型"
              clearable
              
            >
              <el-option
                v-for="item in versionTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="24">
          <el-form-item label="固件版本" prop="file">
                <UploadFile 
              :max="1024*1024*5"
             
              :limit="1"
              :fileList.sync="form.file"></UploadFile>
          </el-form-item>
        </el-col>
     

        <el-col :span="24" v-if="model != 'view'">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
            >
              {{model =='add'?'提交':'修改'}}
            </el-button>
            <el-button
              icon="el-icon-circle-close"
              @click="cancleRecord"
              size="small"
            >
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import UploadFile from '@/views/components/uploadFile.vue';
import {getDictionary} from '@/api/common';
import {firmwareUpload} from '../api/index'

export default {
  props: {
    row: {
      default: {},
    },

    model: {},
  },
  components: { UploadFile },
  data() {

    return {
        fileList:[],
    versionTypeList:[],
    firmwareTypeList:[],
      form: {
        versionType: "",
        firmwareType: "",
        file:[]
      },

      formRules: {
        versionType:[{ required: true, message: "版本类型不能为空", trigger: "blur" },],
        firmwareType:[{ required: true, message: "固件类型不能为空", trigger: "blur" },],
         file:[{ required: true, message: "固件版本不能为空", trigger: "blur" },]
      },
    };
  },
  created() {
    console.log("**", this.model,this.row);
      this.initData()
   
  },
  methods: {
   
    async initData() {
        
        getDictionary('park_version_type').then(res=>{
            this.versionTypeList = res.data
        })
    },
    saveRecord() {
     
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
         let obj = new FormData();
         obj.append('versionType',this.form.versionType)
          obj.append('firmwareType',this.form.firmwareType)
     
          obj.append('file',this.form.file[0])
        console.log('****----',obj)
          firmwareUpload(obj).then((res) => {
              this.$message.success("新增成功");
              this.$emit("success");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancleRecord() {
      this.$emit("cancle");
    },
   
  },
};
</script>
